import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { DropDownComponent } from "./drop-down/drop-down.component";
import { EditorComponent } from "./editor/editor.component";
import { GroupTitleComponent } from "./group-title/group-title.component";
import { LabelTextComponent } from "./label-text/label-text.component";
import {TextLoaderComponent  } from "./text-loader/text-loader.component";"./title-text/title-text.component";
import { WarningTextComponent } from "./warning-text/warning-text.component";
import { WordCountTextComponent } from "./word-count-text/word-count-text.component";
import { SearchBoxComponent } from "./search-box/search-box.component";

// module 
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { FormsModule } from '@angular/forms';

const comLists=[
  DropDownComponent,
  EditorComponent,
  GroupTitleComponent,
  LabelTextComponent,
  TextLoaderComponent,
  WarningTextComponent,
  WordCountTextComponent,
  SearchBoxComponent,
  RadioButtonComponent,
  CheckBoxComponent
]
@NgModule({
  declarations: [
    comLists
  ],
  imports: [
    CommonModule,
    RichTextEditorAllModule,
    FormsModule
  ],
  exports:[
    comLists
  ]
})
export class TextGpModule { }
